// Difficulty categories. The backend returns them as unordered objects, and their names
// change between competitions - short/medium/long today, easy/medium/hard and the swe_*
// benchmarks in older ones - so nothing here may assume a fixed set.

const RANK: Record<string, number> = {
  short: 0,
  easy: 0,
  medium: 1,
  long: 2,
  hard: 2,
  swebench_verified: 3,
  swe_explorer_explore: 4,
  swe_explorer_edit: 5,
};

const LABELS: Record<string, string> = {
  swebench_verified: "swebench",
  swe_explorer_explore: "explore",
  swe_explorer_edit: "edit",
};

function rankOf(category: string): number {
  return RANK[category.trim().toLowerCase()] ?? Number.POSITIVE_INFINITY;
}

/**
 * Easiest first, unknown categories last and alphabetical among themselves. Object key
 * order would otherwise decide the column order, and alphabetical alone would render
 * long, medium, short - which reads as a difficulty scale that runs backwards.
 */
export function compareCategories(a: string, b: string): number {
  const ra = rankOf(a);
  const rb = rankOf(b);
  return ra === rb ? a.localeCompare(b) : ra - rb;
}

export function categoryLabel(key: string): string {
  return LABELS[key] ?? key;
}
